import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=57f0b930&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=57f0b930&scoped=true&lang=css&"
import style1 from "@/modules-config/css/style.css?vue&type=style&index=1&data-portal=portal-home&lang=css&"
import style2 from "@/../public/css/bootstrap.min.css?vue&type=style&index=2&data-portal=portal-home&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0b930",
  null
  
)

export default component.exports